import { NgOptimizedImage } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { BreadcrumbComponent } from 'app/shared/components/breadcrumb/breadcrumb.component';
import { LoginCardComponent } from 'app/shared/components/login-card/login-card.component';

/**
 * O `?destino=` só quando é caminho DESTE portal: começa com `/` e não com `//` nem `/\`, que o
 * navegador leria como outro site. Qualquer outro valor vira vazio, e o login segue para o
 * destino padrão do card.
 *
 * Exportada e pura para ser testada sem criar o componente.
 */
export function destinoInterno(valor: string | null | undefined): string {
  const destino = (valor ?? '').trim();

  if (!destino.startsWith('/') || destino.startsWith('//') || destino.startsWith('/\\')) return '';

  return destino;
}

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrl: './signin.component.css',
  imports: [NgOptimizedImage, BreadcrumbComponent, LoginCardComponent],
})
export class SigninComponent {
  /**
   * Para onde voltar depois do login — a tela de Serviços manda a própria URL quando a estrela
   * pede login. Chega da query string (`/login?destino=`).
   */
  readonly destino = input('');

  readonly destinoSeguro = computed(() => destinoInterno(this.destino()));
}
